export default "__VITE_ASSET__BRYmzu0j__"